import {useSelector} from "../../store";
import {useTranslation} from "next-i18next";
import {useForex} from "../../hooks/use-forex";

interface ForexProps {
    amount: string;
    currency: string;
}

export function Forex({amount, currency}: ForexProps) {

    const amountParsed = parseFloat(amount)

    const {selectedCurrency} = useSelector((state) => state.persisted);

    const {t} = useTranslation();

    const navLanguage = (typeof navigator === "undefined") ? "en" : navigator.language.split("-")[0].toLowerCase()


    const {convertNoFormat} = useForex()

    const formattedFrom = new Intl.NumberFormat(navLanguage, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amountParsed);


    if (currency === selectedCurrency) {
        return <span>{formattedFrom}</span>
    } else {
        return <>{formattedFrom} <span style={{
            fontSize: "smaller",
            fontWeight: "bold",
            color: "#636363"
        }}>({t("roughly")} {convertNoFormat(
            amountParsed,
            currency
        )} {selectedCurrency})</span></>;

    }

}
